export const HortizontalNavigationEventFeature = {
    PRIMARY: 'primary_navigation',
    SECONDARY: 'secondary_navigation',
    TERTIARY: 'tertiary_navigation',
};
export const AssortmentEntranceEventFeature = {
    PRIMARY: 'primary_category',
    SECONDARY: 'secondary_category',
    TERTIARY: 'tertiary_category',
};
//# sourceMappingURL=CategoryNavigation.types.js.map